exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".table-slim.table-slim.table-slim.table-slim {\n  padding-left: 0;\n  padding-right: 4px;\n}\n", ""]);

